var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementorPro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "103px",
    height: "112px",
    viewBox: "0 0 103 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9DAAC3CA-6E34-4A59-AF81-9323384C82EC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landingpage",
    transform: "translate(-957.000000, -5174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(0.000000, 4798.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plugins-Copy",
    transform: "translate(273.000000, 325.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-25",
    transform: "translate(641.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(43.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elementor-pro-logo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.9997826,9.00021739 L5,9.00021739 C2.2323913,9.00021739 0.000434782609,11.2323913 0.000434782609,14.0002174 L0.000434782609,103.999783 C0.000434782609,106.767609 2.2323913,108.999783 5,108.999783 L94.9997826,108.999783 C97.7676087,108.999783 99.9995652,106.767609 99.9995652,103.999783 L99.9995652,14.0002174 C99.9995652,11.2323913 97.7676087,9.00021739 94.9997826,9.00021739",
    id: "Path",
    fill: "#D63362",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 27.7904348,
    y: 36.7904348,
    width: 8.88369565,
    height: 44.4193478
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 45.5578261,
    y: 72.3258696,
    width: 26.673913,
    height: 8.88391304
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 45.5578261,
    y: 54.5578261,
    width: 26.673913,
    height: 8.88369565
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 45.5578261,
    y: 36.7680435,
    width: 26.673913,
    height: 8.88369565
  }), /*#__PURE__*/React.createElement("g", {
    id: "pro",
    transform: "translate(61.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1C2335",
    strokeWidth: 3,
    fill: "#D63462",
    x: -1.5,
    y: -1.44642857,
    width: 42,
    height: 23.8928571,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.10546875,15 L9.10546875,11.7597656 L10.2363281,11.7597656 C11.0214844,11.7597656 11.6210938,11.71875 12.0351562,11.6367188 C12.3398438,11.5703125 12.6396484,11.4345703 12.9345703,11.2294922 C13.2294922,11.0244141 13.4726562,10.7421875 13.6640625,10.3828125 C13.8554688,10.0234375 13.9511719,9.58007812 13.9511719,9.05273438 C13.9511719,8.36914062 13.7851562,7.81152344 13.453125,7.37988281 C13.1210938,6.94824219 12.7089844,6.66796875 12.2167969,6.5390625 C11.8964844,6.453125 11.2089844,6.41015625 10.1542969,6.41015625 L10.1542969,6.41015625 L7.37109375,6.41015625 L7.37109375,15 L9.10546875,15 Z M10.0546875,10.3007812 L9.10546875,10.3007812 L9.10546875,7.86328125 L9.94335938,7.86328125 C10.5683594,7.86328125 10.984375,7.8828125 11.1914062,7.921875 C11.4726562,7.97265625 11.7050781,8.09960938 11.8886719,8.30273438 C12.0722656,8.50585938 12.1640625,8.76367188 12.1640625,9.07617188 C12.1640625,9.33007812 12.0986328,9.55273438 11.9677734,9.74414062 C11.8369141,9.93554688 11.65625,10.0761719 11.4257812,10.1660156 C11.1953125,10.2558594 10.7382812,10.3007812 10.0546875,10.3007812 L10.0546875,10.3007812 Z M17.1152344,15 L17.1152344,11.4140625 L17.4667969,11.4140625 C17.8652344,11.4140625 18.15625,11.4462891 18.3398438,11.5107422 C18.5234375,11.5751953 18.6972656,11.6943359 18.8613281,11.8681641 C19.0253906,12.0419922 19.3300781,12.4628906 19.7753906,13.1308594 L19.7753906,13.1308594 L21.0292969,15 L23.1035156,15 L22.0546875,13.3242188 C21.640625,12.65625 21.3115234,12.1914062 21.0673828,11.9296875 C20.8232422,11.6679688 20.5136719,11.4277344 20.1386719,11.2089844 C20.8925781,11.0996094 21.4589844,10.8349609 21.8378906,10.4150391 C22.2167969,9.99511719 22.40625,9.46289062 22.40625,8.81835938 C22.40625,8.31054688 22.28125,7.859375 22.03125,7.46484375 C21.78125,7.0703125 21.4482422,6.79589844 21.0322266,6.64160156 C20.6162109,6.48730469 19.9492188,6.41015625 19.03125,6.41015625 L19.03125,6.41015625 L15.3808594,6.41015625 L15.3808594,15 L17.1152344,15 Z M18.6176072,10.0420971 L17.1152344,10.0429688 L17.1152344,7.86328125 L18.67125,7.86357422 C19.2534375,7.86533203 19.6078125,7.875 19.734375,7.89257812 C20.015625,7.93945312 20.2333984,8.05175781 20.3876953,8.22949219 C20.5419922,8.40722656 20.6191406,8.640625 20.6191406,8.9296875 C20.6191406,9.1875 20.5605469,9.40234375 20.4433594,9.57421875 C20.3261719,9.74609375 20.1640625,9.8671875 19.9570312,9.9375 C19.75,10.0078125 19.2304688,10.0429688 18.3984375,10.0429688 L18.6176072,10.0420971 Z M27.8671875,15.1464844 C29.1289062,15.1464844 30.1367188,14.7548828 30.890625,13.9716797 C31.6445312,13.1884766 32.0214844,12.1035156 32.0214844,10.7167969 C32.0214844,9.31835938 31.6416016,8.2265625 30.8818359,7.44140625 C30.1220703,6.65625 29.109375,6.26367188 27.84375,6.26367188 C27.1445312,6.26367188 26.5273438,6.37695312 25.9921875,6.60351562 C25.5898438,6.77148438 25.2197266,7.02929688 24.8818359,7.37695312 C24.5439453,7.72460938 24.2773438,8.1171875 24.0820312,8.5546875 C23.8203125,9.1484375 23.6894531,9.8828125 23.6894531,10.7578125 C23.6894531,12.125 24.0664062,13.1982422 24.8203125,13.9775391 C25.5742188,14.7568359 26.5898438,15.1464844 27.8671875,15.1464844 Z M27.8613281,13.6640625 C27.1699219,13.6640625 26.5996094,13.4130859 26.1503906,12.9111328 C25.7011719,12.4091797 25.4765625,11.671875 25.4765625,10.6992188 C25.4765625,9.7109375 25.6953125,8.97167969 26.1328125,8.48144531 C26.5703125,7.99121094 27.1464844,7.74609375 27.8613281,7.74609375 C28.5761719,7.74609375 29.1494141,7.98828125 29.5810547,8.47265625 C30.0126953,8.95703125 30.2285156,9.69140625 30.2285156,10.6757812 C30.2285156,11.671875 30.0068359,12.4189453 29.5634766,12.9169922 C29.1201172,13.4150391 28.5527344,13.6640625 27.8613281,13.6640625 Z",
    id: "PRO",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementorPro);
export default __webpack_public_path__ + "static/media/elementor-pro.1c8666d190e08a0a249f121447ff6454.svg";
export { ForwardRef as ReactComponent };